<script setup lang="ts">
    import AppLogoIcon from '@/components/AppLogoIcon.vue';
    import KeepersLogo from '@/components/icons/KeepersNavLogo.vue';
</script>

<template>
    <div class="flex size-8">
        <KeepersLogo class="size-5" />
        <!-- <AppLogoIcon class="size-5 fill-current text-white dark:text-black" /> -->
    </div>
</template>
